module.exports = __webpack_public_path__ + "img/egg-picture.2919e296.jpg";